import { useState, useEffect } from 'react';
const BuildInfo = () => {
    const [data, setData] = useState([]);
    const [isHover, setIsHover] = useState(false);

    let [link, setLink] = useState(false);

    const buildInfoCntStyle = {
        flex: 'auto',
        marginTop: '4px',
        marginLeft: '8px',
    };

    const buildInfoLinkStyle = {
        userSelect: 'none',
        fontSize: '.8rem',
        background: isHover ? '#292929' : '#575656cf',
        padding: '4px 13px',
        borderRadius: '10px',
        letterSpacing: '.5px',
        color: 'white',
        textDecoration: isHover ? 'underline' : 'none',
        transitionDuration: '.5s',
    };

    const handleMouseEnter = () => {
        setIsHover(true);
    };

    const handleMouseLeave = () => {
        setIsHover(false);
    };

    useEffect(() => {
        const getBuildInfo = () =>
            fetch(`${window.$baseUrl}/version.txt`)
                .then((response) => response.text())
                .then((data) => {
                    // set data
                    setData(data);

                    // set version -> jira link
                    if (!/^[a-zA-Z0-9]+$/.test(data)) {
                        let version = data.replace('release/', '');
                        setLink(
                            `https://c24-aurumtours.atlassian.net/issues/?jql=project+%3D+AURUM+AND+fixVersion+%7E+%22*${version}%22`
                        );
                    }
                })
                .catch((err) => console.error(err));

        // fetch : build data
        ['integration', 'staging'].includes(process.env.VITE_ENV) &&
            window.location.hostname !== 'localhost' &&
            getBuildInfo();
    }, []);

    return (
        <>
            {data.length > 0 && (
                <div style={buildInfoCntStyle}>
                    <a
                        href={link}
                        target={'_blank'}
                        style={buildInfoLinkStyle}
                        className={'build-info'}
                        title={'aktuelle Release-Ticket-Liste'}
                        rel="noopener noreferrer"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}>
                        {data}
                    </a>
                </div>
            )}
        </>
    );
};

export default BuildInfo;
